export default "__VITE_ASSET__lto_offn__"